import { FileText, ListChecks, GitFork } from "lucide-react";

const outputs = [
  {
    icon: <FileText className="w-8 h-8" />,
    title: "Structured Decision Doc",
    description: "Clear documentation of context, recommendation, and next steps"
  },
  {
    icon: <ListChecks className="w-8 h-8" />,
    title: "Pros & Cons Analysis",
    description: "Detailed evaluation of each option with supporting rationale"
  },
  {
    icon: <GitFork className="w-8 h-8" />,
    title: "Risk Assessment",
    description: "Identification of potential risks and mitigation strategies"
  }
];

export const ExpectedOutputs = () => {
  return (
    <div>
      <h3 className="text-lg font-medium mb-4">Expected Outputs</h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {outputs.map((output, index) => (
          <div 
            key={index}
            className="bg-accent/50 p-6 rounded-lg text-center"
          >
            <div className="inline-flex items-center justify-center w-12 h-12 mb-4 bg-white rounded-lg">
              {output.icon}
            </div>
            <h3 className="text-lg font-medium mb-2">{output.title}</h3>
            <p className="text-gray-600 text-sm">{output.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};